import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const DOCTOR = {
  id: 'admin.khuyana.doctor',
  title: 'Administración de Doctores',

  labels: {
    ...COMMONS,
    specialties: 'Especialidades',
    dateBorn: 'Nacimiento',
    username: 'Usuario',
    senescyt: 'Registro de SENESCYT',
    quitclaim: 'Fecha de salida',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    residence: 'Residencia',
    residencePlaceholder: 'Lugar de residencia...',
    addressPlaceholder: 'Dirección...',
    specialtiesDialog: 'Asociar especialidades',
    generatePassQuestion: '¿Estás seguro de generar nuevamente la contraseña del doctor {{fullName}}?',
    statusQuestion: '¿Estás seguro de {{status}} el doctor {{fullName}}',
    roleQuestion: '¿Estás seguro de asociar este {{role}} a {{fullName}}?',
    passSuccess: 'La contraseña fue generada.',
    yes: 'Si',
    no: 'No',
  },

  actions: {
    ...ACTIONS,
    add: `${ACTIONS.add} Doctor`,
    edit: `${ACTIONS.edit} Doctor`,
    generateUser: 'Generar usuario',
    generatePass: 'Generar contraseña',
    setSpecialties: 'Asociar especialidades',
    addSpecialty: 'Agregar especialidad',
    roleCounter: 'Rol: Recepción',
    roleVitalSign: 'Rol: Signos Vitales',
    roleDoctor: 'Rol: Doctor',
  }
};
